import { Button, SVG } from 'Components';
import { useNavigate } from 'react-router';
import { ROUTES, USER_ROLES, SVG_TYPE } from 'Shared/enums';
import { useEffect, useState } from 'react';
import SingleCategory from './components/SingleCategory/SingleCategory';
import { MainType } from './Container';
import { generatePath } from 'react-router-dom';
import { mapCategoriesByLabel } from 'Shared/utils/categoryGroups';

function SelectCategory(props: MainType) {
  const { actions, drivingCategories, authorizedUser } = props;
  const { getDrivingCategory, setUserCategory, getAuthorizedUser } = actions;
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [showError, setShowError] = useState(false);
  const [mappedCategories, setMappedCategories] = useState([]);

  //get state from useNavigate

  useEffect(() => {
    getDrivingCategory();
    getAuthorizedUser();
  }, []);

  useEffect(() => {
    const selectedId = authorizedUser?.categoryId;
    if (selectedId && drivingCategories.length > 0) {
      const category = drivingCategories.find((item) => item.value === selectedId);
      setSelectedCategory(category ? category.value : null);
    }
  }, [authorizedUser, drivingCategories]);
  const changeCategory = localStorage.getItem('CHANGE_CATEGORY');

  const handleSubmit = async () => {
    if (selectedCategory !== null) {
      let result;
      if (changeCategory) {
        result = await setUserCategory(selectedCategory, false);
      } else {
        result = await setUserCategory(selectedCategory, true);
      }
      if (result) {
        if (authorizedUser.role === USER_ROLES.ADMIN) {
          navigate({ pathname: generatePath(ROUTES.USERS, { role: 'client', page: '1' }) });
        } else {
          // sessionStorage.setItem('refreshDepartments', 'true');
          navigate({ pathname: generatePath(ROUTES.LEARNING, { submenu: 'departments' }) });
        }
        getAuthorizedUser();
      }
    } else {
      setShowError(true);
    }
  };

  const handleCategoryClick = (value: number) => {
    setSelectedCategory(value);
    setShowError(false);
  };

  useEffect(() => {
    setMappedCategories(mapCategoriesByLabel(drivingCategories));
  }, [drivingCategories]);

  return (
    <div className="select-category__wrapper login-page ">
      <main className="login-page__body">
        <div className="login-page__content-wrapper">
          <h2 className="login-page__title">
            {changeCategory && (
              <span onClick={() => navigate(-1)}>
                <SVG type={SVG_TYPE.CHEVRONE} />
              </span>
            )}
            Wybierz kategorię
          </h2>
          <p className="login-page__description">Wybierz kategorię prawa jazdy, do której chcesz się przygotować</p>
          <div className="select-category">
            <p className="single-category__label">Motory i skutery</p>
            {mappedCategories[0]?.map((category) => (
              <SingleCategory key={category.label} category={category} onClick={handleCategoryClick} selectedCategory={selectedCategory} />
            ))}

            <p className="single-category__label">Samochody osobowe i quady</p>
            {mappedCategories[1]?.map((category) => (
              <SingleCategory key={category.label} category={category} onClick={handleCategoryClick} selectedCategory={selectedCategory} />
            ))}
            <div>
              <p className="single-category__label">Samochody ciężarowe i autobusy</p>
              {mappedCategories[2]?.map((category) => (
                <SingleCategory key={category.label} category={category} onClick={handleCategoryClick} selectedCategory={selectedCategory} />
              ))}
            </div>

            <p className="single-category__label">Ciągniki i tramwaje</p>
            {mappedCategories[3]?.map((category) => (
              <SingleCategory key={category.label} category={category} onClick={handleCategoryClick} selectedCategory={selectedCategory} />
            ))}
          </div>
        </div>
        <div className={`login-page__error-category ${showError ? 'login-page__error-category--visible' : ''}`}>Pole wymagane</div>
        <div className="login-page__buttons">
          <Button label={'Potwierdź'} type="submit" onClick={() => handleSubmit()} />
        </div>
      </main>
    </div>
  );
}

export default SelectCategory;
